import {HttpClient} from '@angular/common/http';

import {KeycloakService} from 'keycloak-angular';

export const LOCAL_STORAGE_TOKEN_KEY_NAME = 'token';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY_NAME = 'refresh_token';
export const LOCAL_STORAGE_ID_TOKEN_KEY_NAME = 'id_token';

export const initializer = (keycloakService: KeycloakService, httpClient: HttpClient): () => Promise<boolean> => {
  return (): Promise<boolean> => {
    return httpClient.get('/authent/api/v1/keycloak/keycloak.json', {responseType: 'json'}).toPromise().then(
      (keycloakConfig: any) => {
        return keycloakService.init({
          config: keycloakConfig,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false,
          },
          enableBearerInterceptor: true,
          bearerExcludedUrls: [],
          bearerPrefix: 'Bearer'
        });
      }
    );

  };
};
